import { Box, Text } from '@chakra-ui/react';
import { format } from 'date-fns-tz';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { CellValue } from 'react-table';

import Table from 'components/Table';
import { normalizeDate } from 'utils/helpers';

const itemsPerPage = 10;

const SingleRequest: React.FC<{ data: Array<any> }> = ({ data }) => {
  const [paginationData, setPaginationData] = useState<any>({
    current_page: 0,
    total_items: 0,
    per_page: itemsPerPage,
    last_page: 0,
    offset: 10,
  });

  useEffect(() => {
    const pageCount = Math.ceil(data.length / itemsPerPage);

    const updatedPagination = {
      current_page: 0,
      total: data.length,
      per_page: itemsPerPage,
      last_page: pageCount,
      offset: 0,
    };

    setPaginationData(updatedPagination);
  }, [data]);

  const columns = useMemo(
    () => [
      {
        Header: 'Time Off Category',
        accessor: 'category',
        Cell: (data: CellValue) => {
          return (
            <Box>
              <Text textTransform="capitalize">{data.row.original?.category_name || '- '}</Text>
            </Box>
          );
        },
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: (data: CellValue) => {
          return (
            <Box
              display="inline-block"
              color="white"
              textTransform="uppercase"
              padding="4px 8px"
              mt={1}
              backgroundColor="success.500"
              borderRadius="4px"
            >
              <Text fontSize="xs">{data.value}</Text>
            </Box>
          );
        },
      },

      {
        Header: 'Type',
        accessor: 'category_type',
      },
      {
        Header: 'Period',
        accessor: 'start_date',
        width: 240,
        Cell: (data: CellValue) => {
          const startDate = new Date(normalizeDate(data.row.original.start));
          const endDate = new Date(normalizeDate(data.row.original.end));

          const formattedStartDate = startDate ? format(startDate, 'dd MMM yyyy') : '';
          const formattedEndDate = startDate ? format(endDate, 'dd MMM yyyy') : '';

          return (
            <Text>
              {formattedStartDate} - {formattedEndDate}
            </Text>
          );
        },
      },
      {
        Header: 'Duration (Hours)',
        accessor: 'requested_hours',
        Cell: (data: CellValue) => {
          return <Text>{data.row.original?.requested_hours}</Text>;
        },
      },
    ],

    []
  );

  const handlePageSizeChange = (pageSize: number) => {
    setPaginationData((prev: any) => {
      const pageCount = Math.ceil(data.length / pageSize);
      return {
        ...prev,
        per_page: pageSize,
        current_page: 0,
        offset: 0,
        last_page: pageCount,
      };
    });
  };

  const handlePageChange = useCallback((selectedPageIndex: number) => {
    setPaginationData((prev: any) => {
      const offset = selectedPageIndex * prev.per_page;
      return {
        ...prev,
        current_page: selectedPageIndex,
        offset: offset,
      };
    });
  }, []);

  const currentItems = data.slice(paginationData.offset, paginationData.offset + paginationData.per_page);

  return (
    <Table
      columns={columns}
      data={currentItems || []}
      paginationData={paginationData}
      onPageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      enableRowSelect
      paginationStyle="rowsPerPage"
    />
  );
};
export default SingleRequest;
